import Vue from 'vue'
import Vuesax from 'vuesax'
import VueQrcodeReader from 'vue-qrcode-reader'
import App from './App.vue'
import router from './router/index'
import store from './store'
import './registerServiceWorker'

import 'material-icons/iconfont/material-icons.css'
import 'vuesax/dist/vuesax.css'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.use(VueQrcodeReader)

Vue.use(Vuesax, {
  theme: {
    colors: {
      primary: '#e6242b'
    }
  }
})
